import React from 'react';
import { Avatar } from './Avatar';
import { AlignerProgress } from './patientsTable/AlignerProgress';

interface PatientRecapCardProps {
    name: string;
    profilePictureUrl: string;
    profileThumbnailUrl?: string | null;
    treatmentStatus: string;
    duration: string;
    currentAligner: number;
    totalAligners: number;
}

const PatientRecapCard: React.FC<PatientRecapCardProps> = ({
    name,
    profilePictureUrl,
    profileThumbnailUrl,
    treatmentStatus,
    duration,
    currentAligner,
    totalAligners
}) => {
    const hasAlignerProgress =
        Number.isFinite(currentAligner) &&
        Number.isFinite(totalAligners) &&
        totalAligners > 0 &&
        currentAligner > 0;

    return (
        <div className="bg-blue-50 rounded-xl p-3 flex items-center gap-8 w-full">
            <div className="flex-shrink-0 w-14 h-14">
                <Avatar
                    user={{ name: name || 'N/A', email: '' }}
                    imageURL={profilePictureUrl || ''}
                    thumbnailURL={profileThumbnailUrl ?? undefined}
                />
            </div>

            <div className="flex min-w-0 flex-[50_1_0] flex-col gap-0.5">
                <p className="text-xs font-bold text-gray-600">{name || '-'}</p>
                <p className="text-sm text-gray-900">{treatmentStatus || '-'}</p>
            </div>

            <div className="flex-shrink-0 h-14 w-px bg-gray-300" />

            <div className="flex min-w-0 flex-[35_1_0] flex-col gap-0.5">
                <p className="text-xs font-bold text-gray-600">In treatment for</p>
                <p className="text-sm text-gray-900">{duration}</p>
            </div>

            <div className="flex-shrink-0 h-14 w-px bg-gray-300" />

            <div className="flex min-w-0 flex-[15_1_0] flex-col gap-0.5 items-start">
                <p className="text-xs font-bold text-gray-600">Aligner #</p>
                {hasAlignerProgress ? (
                    <AlignerProgress
                        current={currentAligner}
                        total={totalAligners}
                        className="w-11 h-11"
                    />
                ) : (
                    <span className="flex items-center justify-start w-11 h-11 text-sm text-gray-500">
                        -
                    </span>
                )}
            </div>
        </div>
    );
};

export default PatientRecapCard;
